import { Config } from './config.base';

const developmentConfig: Config = {
  api: {
    // baseUrl: 'http://192.168.1.26:3000',
    baseUrl: 'https://api-dev.meetfinex.com',
    timeout: 5000,
    retryAttempts: 3,
  },
  features: {
    enableCache: false,
    enableAnalytics: false,
  },
  auth: {
    tokenExpiration: 30,
    refreshTokenExpiration: 7,
  },
};

export default developmentConfig; 